__turbopack_context__.v({
  "headerLink": "Header-module__g-mymW__headerLink",
  "headerLinkActive": "Header-module__g-mymW__headerLinkActive",
});
